// extracted by mini-css-extract-plugin
export default {"-large":"T12OsSgt_ZqL7v1KQdsQ","container":"HfpnHnxYV8FBYNv5vB6w"};